import Breadcrumb from 'components/Breadcrumb'
import Typography from 'components/Typography'
import styles from './Header.module.scss'
import * as events from 'pages/regioes-atendidas/events'

const Header = () => {
  return (
    <div className={styles.ecRegionsServedHeaderContainer}>
      <div className={styles.ecRegionsServedHeaderLeft}>
        <Breadcrumb
          list={[
            {
              label: 'Início',
              to: '/',
              onClick: (label, url) => events.breadcrumbEvent(label, url),
            },
            {
              label: 'Regiões Atendidas',
              to: '/regioes-atendidas',
              active: true,
            },
          ]}
        />
        <Typography variant="TitleBig" as="h1" bold>
          Regiões atendidas
        </Typography>
      </div>
      <div>
        <Typography variant="TitleSmall">
          Explore as cidades e bairros em que a EmCasa atua. Saiba mais
          informações para escolher onde comprar o seu imóvel
        </Typography>
      </div>
    </div>
  )
}

export default Header
